module.exports = __webpack_public_path__ + "static/media/mobile.71a7a474.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile.png
// module id = 960
// module chunks = 0